const CAROUSEL_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20astronaut%20floating%20in%20deep%20space%2C%20dramatic%20nebula%20colors%2C%20epic%20scale%2C%20cinematic%20lighting%2C%20movie%20poster%20quality%2C%20dark%20warm%20tones%2C%20no%20text&width=800&height=450&seq=carousel-01&orientation=landscape',
    title: '星际穿越2：新纪元',
    category: '科幻巨制',
    desc: '年度最受期待的科幻大片，带你探索未知宇宙边界。',
    tag: '4K高清',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20scene%20with%20couple%20silhouette%20against%20warm%20sunset%2C%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20style%2C%20dark%20moody%20tones%2C%20no%20text&width=800&height=450&seq=carousel-02&orientation=landscape',
    title: '命运之轮',
    category: '热门韩剧',
    desc: '跨越时空的浪漫爱情，16集全高清完整版。',
    tag: '全集上线',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20scene%20with%20detective%20in%20rainy%20alley%2C%20noir%20lighting%2C%20neon%20reflections%2C%20suspenseful%20atmosphere%2C%20cinematic%20film%20quality%2C%20urban%20night%20setting%2C%20no%20text&width=800&height=450&seq=carousel-03&orientation=landscape',
    title: '暗夜追踪',
    category: '悬疑推理',
    desc: '国产悬疑天花板，每集反转烧脑到停不下来。',
    tag: '热播中',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20dragon%20kingdom%20with%20magical%20glowing%20landscape%2C%20epic%20adventure%20atmosphere%2C%20colorful%20ethereal%20lighting%2C%20hand-drawn%20animation%20style%2C%20cinematic%20composition%2C%20no%20text&width=800&height=450&seq=carousel-04&orientation=landscape',
    title: '龙之秘境',
    category: '动画电影',
    desc: '国漫巅峰视觉盛宴，龙族秘境的奇幻冒险之旅。',
    tag: '独家首发',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20explosion%20scene%20with%20hero%20running%20from%20fire%2C%20intense%20dramatic%20lighting%2C%20Hollywood%20blockbuster%20style%2C%20cinematic%20action%20photography%2C%20warm%20explosion%20colors%2C%20no%20text&width=800&height=450&seq=carousel-05&orientation=landscape',
    title: '深海救援',
    category: '灾难大片',
    desc: '惊心动魄的深海救援行动，震撼视听不容错过。',
    tag: 'HD高清',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">热门推荐</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            本周最受关注的影视内容，口碑与热度齐飞
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-200/70 border border-background-300/30 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-transparent to-transparent"></div>
                <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-bold rounded-md bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-[10px] font-medium text-primary-400 uppercase tracking-wider whitespace-nowrap">
                  {item.category}
                </span>
                <h3 className="mt-1 text-sm md:text-base font-semibold text-foreground-100">{item.title}</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}